// app-pages/CreateYourModel/CreateModelSuccessPage.tsx
"use client";
import { Flex, Text, Button, Box } from "@chakra-ui/react";
import { Jumbotron } from "components";
import { useRouter } from "next/navigation";

const CreateYourModelSuccess = () => {
  const router = useRouter();

  return (
    <Flex align="center" direction="column">
      <Jumbotron>
        <Flex h="200px" textAlign="center" direction="column" align="center">
          <Text
            mt="30px"
            fontSize={{ base: "38px", lg: "58px" }}
            fontWeight="semibold"
            style={{
              background: "linear-gradient(to right,  #FFE1FF 40%, #A4DBEE 60%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              MozBackgroundClip: "text",
            }}
            w={{ base: "310px", lg: "750px" }}
          >
            Success
          </Text>
        </Flex>
      </Jumbotron>
      <Text textAlign="center" maxW="700px">
        Your model is now being trained. This process usually takes around 20 minutes. We will
        notify you by email when it’s ready to use.
      </Text>
      <Button
        w="290px"
        mt="70px"
        bg="transparent"
        border="1px solid white"
        color="white"
        onClick={() => router.push("/dashboard")}
      >
        My Models
      </Button>
      <Box id="spacer" h={{ base: "200px", lg: "500px" }}></Box>
    </Flex>
  );
};

export default CreateYourModelSuccess;
